import { notification } from "ant-design-vue";
import { reactive } from "vue";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { onClickActiveAll, onClickArchiveAll, onClickCreate, onClickDeleteAll, onClickEdit, onClickView } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import {
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView
} from "../../../../utils/page";
import { flatWhereGroup } from "../../../../utils/search";
import { openModalForm as openModalFormConfirmApprove } from "../../storage-location/request/modal/confirm-approve.logic";
import { createConditionAction } from "./request.condition";
import { callActiveAll, callArchiveAll, callDeleteAll, callSearch } from "./request.logic";
import { createColumns } from "./request.section";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/request";

export const callRequestAll = ({ forms }) => store.dispatch(`${actionPrefix}/requestAll`, { data: forms });

export const onSearch = ({ props, page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...where, ...createWhereFor({ props })], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const createWhereFor = () => {
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    whereGroup.push([{ name: "refToApproveBy.username", type: "String", operator: "=", value: userInfo.username }, { logic: "AND", name: "refRequestDoc.key", type: "String", operator: "=", value: "01" }]);
    return flatWhereGroup({ where: whereGroup, logic: "OR" });
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    state.manages = [
        createManageSelect({ menuContext }),
        {
            icon: () => <CIcon file="check.svg"></CIcon>,
            text: () => i18n.global.t("button.signApprove"),
            force: true,
            visible: () => true,
            rowSelection: true,
            buttonProp: { class: "btn-success" },
            onClick: ({ rowSelection }) => {
                openModalFormConfirmApprove({
                    onOk: record => {
                        const forms = rowSelection.selectedRows.map(d => ({ ...d, refStatus: record.refStatus }));
                        setIsLoading(true);
                        callRequestAll({ forms })
                            .then(() => notification["success"]({ message: i18n.global.t(`views.request.modal.approve.${record.refStatus?.key}`) }))
                            .then(() => onSearch({ props, page: state.page }))
                            .finally(() => setIsLoading(false));
                    }
                });
            },
            getCheckboxProps: ({ record }) => ({ disabled: record.refStatus?.key !== "waitApprove" })
        },
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading })
        }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction.canEdit({ props, record })
        })
    ];
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: ["**", "refHazDiscuss.**", "refHazDiscussTemp.**"],
            sort: [/* { name: "refStatus.seq", type: "ASC" } ,*/ { name: "updateDate", type: "DESC" }]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction()
});
